import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import enptyProcess from "../../../assets/images/enpty-process.png";
import search from "../../../assets/images/search-icon.png";
import EmptyDataView from "~/components/nodataview";
import { Skeleton } from "primereact/skeleton";
import StatusBadge from "~/Pages/Process/components/StatusBadge";
import { Link } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import useDateTime from "~/hooks/useDateTime";
import { getStatusOptions, StatusKey } from "~/utils/status";
import { format, parseISO } from "date-fns";

const MyProcessesTable = ({
  data,
  loading,
  page,
  rows,
  totalRecords,
  onPageChange,
  isDataAvailable,
  sortMeta,
  onSort,
  searchQuery,
}) => {
  const { formatDateTime } = useDateTime();
  const skeletonRows = [...Array(5)];
  const statusOption = getStatusOptions([
    StatusKey.IN_PROGRESS,
    StatusKey.COMPLETED,
    StatusKey.OVERDUE,
    StatusKey.NOT_NEEDED,
    StatusKey.NOT_STARTED,
  ]);
  const getStatus = (status) => {
    return statusOption.find((data) => data?.code === status?.code);
  };

  const getDeadlineDate = (field) => {
    if (field?.start_date) {
      const deadline =
        new Date(field?.start_date).getFullYear() +
        new Date(field?.start_date).toLocaleDateString("default", {
          month: "2-digit",
        });
      return deadline;
    }
  };

  const getDeadlineDatePayrollPlus = (field) => {
    if (field?.start_date) {
      const date = parseISO(field.start_date);
      return format(date, "MMMM yyyy");
    }
    return "";
  };

  const getSequenceNumber = (field) => {
    if (field?.sequence) {
      return `_${field?.sequence}`;
    }
    return "";
  };

  return (
    <div className="process__table--container">
      {isDataAvailable ? (
        <DataTable
          value={loading ? skeletonRows : data}
          className="datatable-right-align"
          lazy
          paginator={totalRecords > 10}
          first={page * rows}
          rows={rows}
          totalRecords={totalRecords}
          onPage={onPageChange}
          rowsPerPageOptions={[10, 20, 30]}
          sortMode="multiple"
          multiSortMeta={sortMeta}
          onSort={onSort}
          emptyMessage="No results found"
        >
          <Column
            field="process"
            header="Process"
            sortField="name"
            sortable
            body={(field) =>
              loading ? (
                <Skeleton />
              ) : (
                <Link
                  className="request__link"
                  to={`/process/${field?.id}/milestones`}
                >
                  {field?.serviceData?.name === "Payroll +"
                    ? `${getDeadlineDatePayrollPlus(field)} ${field?.name}`
                    : `${field?.name} ${getDeadlineDate(field)}${getSequenceNumber(field)}`}

                  {field.numberof_flagged_milestones > 0 && (
                    <i className="pi pi-flag-fill text-warning ml-2 flag-red-icon"></i>
                  )}
                </Link>
              )
            }
          />
          <Column
            field="entity"
            header="Entity"
            sortable
            sortField="entity"
            body={(field) => (
              <span className="request__link cursor-pointer">
                {loading ? (
                  <Skeleton />
                ) : (
                  <Link
                    className="request__link"
                    to={`/entity/${field?.entityData?.id}/dashboard`}
                  >
                    <ReactCountryFlag
                      countryCode={field?.entityData?.country || ""}
                      svg
                      className="mr-1"
                    />{" "}
                    {field?.entityData?.name}
                  </Link>
                )}
              </span>
            )}
          />
          <Column
            field="serviceLine"
            header="Service Line"
            sortable
            sortField="service"
            body={(field) => (
              <span>{loading ? <Skeleton /> : field?.serviceData?.name}</span>
            )}
          />
          <Column
            field="status"
            header="Status"
            body={(field) =>
              loading ? (
                <Skeleton width="100%" />
              ) : (
                <div className="flex align-items-center">
                  <StatusBadge
                    status={{
                      primary_color: getStatus(field?.statusData)
                        ?.primary_color,
                    }}
                  />
                  <span>{getStatus(field?.statusData)?.name}</span>
                </div>
              )
            }
          />
          <Column
            field="deadline"
            header="Process Period"
            sortable
            sortField="due_date"
            body={(field) => (
              <span>
                {loading ? (
                  <Skeleton />
                ) : (
                  <p>
                    {formatDateTime({
                      date: field?.start_date,
                      dateformat: "MMMM do, yyyy",
                    })}{" "}
                    -{" "}
                    {formatDateTime({
                      date: field?.due_date,
                      dateformat: "MMMM do, yyyy",
                    })}
                  </p>
                )}
              </span>
            )}
          />
        </DataTable>
      ) : (
        <div className="flex flex-column justify-content-center align-items-center p-5">
          <EmptyDataView
            Icon={
              <img
                className="users-card-icon-img"
                src={searchQuery.length ? search : enptyProcess}
                alt="Users Icon"
              />
            }
            Header={
              searchQuery.length
                ? "No results found for your search"
                : "No Processes Available"
            }
            Description={
              searchQuery.length
                ? "We couldn’t find any process matching the criteria selected. Try refining your search"
                : "They will be listed here when ready."
            }
          />
        </div>
      )}
    </div>
  );
};

export default MyProcessesTable;
